
import React from 'react';
import Layout from '@/components/Layout';
import { FadeIn } from '@/components/Animations';
import CycleImportController from '@/components/cycle-tracking/import/CycleImportController';

const CycleImport: React.FC = () => {
  return (
    <Layout>
      <div className="container max-w-6xl py-4 md:py-8">
        <FadeIn>
          <CycleImportController />
        </FadeIn>
      </div>
    </Layout>
  );
};

export default CycleImport;
